
import React from 'react';

interface TeacherFormHeaderProps {
  isEditMode: boolean;
}

export const TeacherFormHeader = ({ isEditMode }: TeacherFormHeaderProps) => {
  return (
    <div className="mb-6">
      <h1 className="text-2xl font-bold">
        {isEditMode ? 'Edit Teacher' : 'Add New Teacher'}
      </h1>
      <p className="text-gray-500 mt-1">
        {isEditMode 
          ? 'Update the teacher information below.'
          : 'Fill in the details to add a new teacher to the system.'}
      </p>
    </div>
  );
};
